import React from 'react'

import topImage from './Image/pexels-valeriya-1639562.jpg'

function Hero() {
  return (
    <div className='max-w-[1640px] mx-auto p-4'>
      <div className='max-h-[500px] relative '>
        {/* overlays */}
        <div className='absolute h-full w-full max-h-[500px] bg-black/30 flex flex-col justify-center rounded-md text-gray-200'>
            <h1 className='px-4 mb-4 text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold'>The<span className='text-orange-500 ml-4'>Best</span></h1>
            <h1 className='px-4 text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold'><span className='text-orange-500 mr-4'>Foods</span>Dilivery</h1>
        </div>
        <img src={topImage} className='max-h-[500px] rounded-md w-full object-cover '  alt='/' />
      </div>
    </div>
  )
}

export default Hero
